import { useQuery } from "@tanstack/react-query";
import { ITDeleteAccountRequestService as api } from "../../../../../services/it-delete-account/itDeleteAccountRequest.service";
import { requestStatus } from "../../../../../constants";
// import { useSelector } from "../../../../../store/store";
import { getStatusBaseOnApprover, getStepBaseOnApprover } from "../utils";
import { transformRequestStatus } from "../../../utils";
import { useUser } from "../../../../../hook";

export const useDeleteAccountRequests = () => {
  const {email} = useUser();
  const emailThienNV = 'thiennv@viags.vn';

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["delete-account-requests"],
    queryFn: () =>
      api.getITDeleteAccountRequests(emailThienNV, requestStatus.submitted),
  });

  const { data: data2 = [] } = useQuery<Array<any>>({
    queryKey: ["delete-account-requests2"],
    queryFn: () =>
      api.getITDeleteAccountRequests(email, requestStatus.submitted),
  });


  const deleteAccountMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === email.toLowerCase()
  );

  const mappedDeleteAccountRequests = data.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, emailThienNV);
    const step = getStepBaseOnApprover(record.fields, emailThienNV);

    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedDeleteAccountRequests2 = data2.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, emailThienNV);
    const step = getStepBaseOnApprover(record.fields, emailThienNV);

    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);


  const mappedDeleteAccountMyRequests = mappedDeleteAccountRequests.filter(
    (record) => record.createdByEmail.toLowerCase() === email.toLowerCase()
  ).sort((a,b) => b.id - a.id);

  const guideLink = "https://drive.google.com/file/d/1Rg6dGNPVm5szgF_M5ZrdbMHr1gFQ2r_e/view"

  return {
    ...restResponse,
    deleteAccountRequests: data,
    deleteAccountMyRequests,
    mappedDeleteAccountRequests,
    mappedDeleteAccountRequests2,
    mappedDeleteAccountMyRequests,
    guideLink,
  };
};
